import gsap from 'gsap';
import { ArrowButton } from './ArrowButton';
import { SIZE_OPTIONS, SIZE_REFS_MAP } from '../../../constants/sizes';
import { QuizActionEvent } from '../../../constants/QuizActionEvent';
import { CommentText3D } from './CommentText3D';

export class CommentTextAndButton extends CommentText3D {
    #button3d;

    constructor(text, index, numTotal, buttonLabel, clickAction) {
        super(text, index, numTotal);

        const button3d = new ArrowButton(clickAction);

        this.add(button3d);

        this.#button3d = button3d;
    }

    _setup() {
        super._setup();
        this.waitForPreload = true;
        this.hasResize = true;
        this.hasStart = true;
        this.clickable = true;
    }

    resize(winWidth, winHeight, orientation, force, pixelRatio) {
        this.#button3d.resize(winWidth, winHeight, orientation, force, pixelRatio);

        return super.resize(winWidth, winHeight, orientation, force, pixelRatio);
    }

    _resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio) {
        super._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);
    }

    destroy() {
        this.stop();
        super.destroy();

        gsap.killTweensOf(this);
    }

    setupPreloadedContent(infrastructure) {
        if (this.#button3d.waitForPreload) this.#button3d.setupPreloadedContent(infrastructure);
        super.setupPreloadedContent(infrastructure);
    }

    _updateTextMetricsAndPosition(orientation) {
        super._updateTextMetricsAndPosition(orientation);

        const { arrowButton, questionScale } = SIZE_REFS_MAP[orientation];

        let x = this.width * 0.5;
        let y = this.shiftY;
        const r = this.radius * questionScale;

        if (orientation === SIZE_OPTIONS.MOBILE_PORTRAIT) {
            y -= arrowButton.radius;
            x -= arrowButton.radius;
            x -= arrowButton.marginSide;
            y -= arrowButton.marginTop;
        } else {
            y += arrowButton.radius;
            x += arrowButton.radius;
            x += arrowButton.marginSide;
        }

        // Angle
        x /= r;

        this.#button3d.position.set(r * Math.sin(x), y, r * Math.cos(x));
        this.#button3d.rotation.y = x;
    }

    // INTERACTION
    start() {
        if (!this.clickable) return;

        this.layers.set(1);

        const handler = (evt) => {
            this.dispatchEvent(evt);
        };

        this.#button3d.addEventListener(QuizActionEvent, handler);
        this.#button3d.start();

        this._eventTransferHandler = handler;
    }

    stop() {
        if (!this.clickable) return;

        if (this._eventTransferHandler) {
            this.#button3d.removeEventListener(QuizActionEvent, this._eventTransferHandler);
            this.#button3d.stop();
            this._eventTransferHandler = undefined;
        }
    }

    set clickAction(val) {
        this.#button3d.clickAction = val;
    }

    get clickAction() {
        return this.#button3d.clickAction;
    }
}
